/**
 * Full-screen reference-image viewer for the kitchen task screens.
 *
 * The three ProductionTaskPage layouts each opened their own copy of this
 * markup and the copies were not identical: the froster driver layout heads it
 * in sentence case and zooms out with a real minus sign (U+2212), the baker
 * delivery and default layouts use title case and an ASCII hyphen. Those
 * strings are therefore props with no defaults — a call site that forgets one
 * is a visible change, not a silent one, and guard-production-task-page.mjs
 * pins each site's exact values.
 *
 * Zoom is owned by the page so closing can reset it; this component only
 * reports the intent.
 */
export default function CakeReferenceLightbox({
  title,
  zoomOutGlyph,
  src,
  zoom,
  onZoomIn,
  onZoomOut,
  onClose,
}) {
  return (
    <div className="fixed inset-0 z-50 bg-black/90 px-3 py-4">
      <div className="mx-auto flex h-full w-full max-w-4xl flex-col gap-3">
        <div className="flex items-center justify-between">
          <p className="text-sm font-semibold text-white">{title}</p>
          <button
            type="button"
            onClick={onClose}
            className="rounded-full bg-white/20 px-3 py-1 text-sm font-bold text-white"
          >
            Close
          </button>
        </div>

        <div className="flex items-center justify-center gap-2">
          <button
            type="button"
            onClick={onZoomOut}
            disabled={zoom <= 1}
            className="rounded-full bg-white/20 px-3 py-1 text-sm font-bold text-white disabled:opacity-40"
          >
            {zoomOutGlyph}
          </button>
          <p className="min-w-[64px] text-center text-sm font-semibold text-white">
            {Math.round(zoom * 100)}%
          </p>
          <button
            type="button"
            onClick={onZoomIn}
            disabled={zoom >= 4}
            className="rounded-full bg-white/20 px-3 py-1 text-sm font-bold text-white disabled:opacity-40"
          >
            +
          </button>
        </div>

        <div className="flex-1 overflow-auto rounded-2xl border border-white/20 bg-black/40 p-2">
          <div className="flex min-h-full min-w-full items-center justify-center">
            <img
              src={src}
              alt="Cake reference full size"
              className="max-h-none max-w-none rounded-xl object-contain"
              style={{ transform: `scale(${zoom})`, transformOrigin: "center center" }}
            />
          </div>
        </div>
      </div>
    </div>
  );
}
